/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
};

export type AnalyzeAssetInput = {
  key: Scalars['String']['input'];
  type: AnalyzeAssetType;
};

export type AnalyzeAssetResponse = {
  __typename?: 'AnalyzeAssetResponse';
  details: Scalars['AWSJSON']['output'];
  status: Scalars['String']['output'];
};

export enum AnalyzeAssetType {
  EInvoice = 'E_INVOICE'
}

export type App = {
  __typename?: 'App';
  mitarbeiterId?: Maybe<Scalars['Int']['output']>;
};

export type ApproveServiceRequestInput = {
  redirect?: InputMaybe<Scalars['Boolean']['input']>;
  serviceRequestId: Scalars['ID']['input'];
  userId: Scalars['Int']['input'];
};

export type AssetsError = {
  __typename?: 'AssetsError';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['AWSJSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AssetsGetSignedUrlGetResponse = {
  __typename?: 'AssetsGetSignedUrlGetResponse';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<AssetsError>;
};

export type AssetsGetSignedUrlPutData = {
  __typename?: 'AssetsGetSignedUrlPutData';
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AssetsGetSignedUrlPutInput = {
  name: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type AssetsGetSignedUrlPutResponse = {
  __typename?: 'AssetsGetSignedUrlPutResponse';
  data?: Maybe<AssetsGetSignedUrlPutData>;
  error?: Maybe<AssetsError>;
};

export type AssetsQuery = {
  __typename?: 'AssetsQuery';
  getSignedUrlGet?: Maybe<AssetsGetSignedUrlGetResponse>;
  getSignedUrlPut?: Maybe<AssetsGetSignedUrlPutResponse>;
};


export type AssetsQueryGetSignedUrlGetArgs = {
  key: Scalars['String']['input'];
};


export type AssetsQueryGetSignedUrlPutArgs = {
  input: AssetsGetSignedUrlPutInput;
};

export type CreatePdfResponse = {
  __typename?: 'CreatePdfResponse';
  error?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};

export type DocumentUpload = {
  __typename?: 'DocumentUpload';
  analysis?: Maybe<Scalars['AWSJSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<UploadMetadata>;
  pdfDoc?: Maybe<Scalars['AWSJSON']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  s3Object?: Maybe<S3Object>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type DocumentsMutation = {
  __typename?: 'DocumentsMutation';
  deleteUpload: Scalars['Boolean']['output'];
  moveUploads: Array<Scalars['Boolean']['output']>;
};


export type DocumentsMutationDeleteUploadArgs = {
  id: Scalars['ID']['input'];
};


export type DocumentsMutationMoveUploadsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  subprojectId: Scalars['ID']['input'];
};

export type DocumentsQuery = {
  __typename?: 'DocumentsQuery';
  uploads: Array<Maybe<DocumentUpload>>;
};

export type EInvoiceInput = {
  key: Scalars['String']['input'];
};

export type EInvoiceResponse = {
  __typename?: 'EInvoiceResponse';
  data?: Maybe<Scalars['AWSJSON']['output']>;
  error?: Maybe<AssetsError>;
};

export type EventInput = {
  name: Scalars['String']['input'];
  payload: Scalars['AWSJSON']['input'];
  source: Scalars['String']['input'];
};

export type EventResponse = {
  __typename?: 'EventResponse';
  EventId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveServiceRequest: ServiceRequestMutationResponse;
  documents?: Maybe<DocumentsMutation>;
  pdf?: Maybe<PdfMutation>;
  projectNotification?: Maybe<ProjectNotification>;
  publish: Array<EventResponse>;
  rejectServiceRequest: ServiceRequestMutationResponse;
  security?: Maybe<SecurityMutation>;
  serviceRequestNotification: ServiceRequestNotification;
  uploadNotification?: Maybe<DocumentUpload>;
  viewer?: Maybe<ViewerMutation>;
};


export type MutationApproveServiceRequestArgs = {
  input: ApproveServiceRequestInput;
};


export type MutationProjectNotificationArgs = {
  data: ProjectNotificationInput;
};


export type MutationPublishArgs = {
  event: EventInput;
};


export type MutationRejectServiceRequestArgs = {
  input: RejectServiceRequestInput;
};


export type MutationServiceRequestNotificationArgs = {
  input: ServiceRequestNotificationInput;
};


export type MutationUploadNotificationArgs = {
  data: UploadNotificationInput;
};

export type OpenServiceRequests = {
  __typename?: 'OpenServiceRequests';
  branches: Array<ServiceRequestBranch>;
  pageInfo: PageInfo;
  serviceRequests: Array<ServiceRequest>;
  sourceSystems: Array<ServiceRequestSourceSystem>;
};

export type OpenServiceRequestsFilter = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  pageCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PdfMutation = {
  __typename?: 'PdfMutation';
  createPdf?: Maybe<CreatePdfResponse>;
};


export type PdfMutationCreatePdfArgs = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  filename: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  id: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissionSet?: Maybe<Array<Scalars['String']['output']>>;
  resources: Array<PermissionResource>;
  type: PermissionGroupType;
};

export type PermissionGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissionSet?: InputMaybe<Array<Scalars['String']['input']>>;
  resources: Array<PermissionResourceInput>;
  type: PermissionGroupType;
};

export enum PermissionGroupType {
  Crudl = 'CRUDL',
  Flags = 'FLAGS'
}

export type PermissionResource = {
  __typename?: 'PermissionResource';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PermissionResourceInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectNotification = {
  __typename?: 'ProjectNotification';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  notification?: Maybe<Scalars['String']['output']>;
};

export type ProjectNotificationInput = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  notification?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  analyzeAsset: AnalyzeAssetResponse;
  assets?: Maybe<AssetsQuery>;
  documents?: Maybe<DocumentsQuery>;
  eInvoice: EInvoiceResponse;
  openServiceRequests?: Maybe<OpenServiceRequests>;
  scratch?: Maybe<Scratch>;
  security?: Maybe<SecurityQuery>;
  serviceRequestQuestionCatalog?: Maybe<QuestionCatalog>;
  viewer: Viewer;
};


export type QueryAnalyzeAssetArgs = {
  input: AnalyzeAssetInput;
};


export type QueryEInvoiceArgs = {
  input: EInvoiceInput;
};


export type QueryOpenServiceRequestsArgs = {
  filter?: InputMaybe<OpenServiceRequestsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryServiceRequestQuestionCatalogArgs = {
  serviceRequestId: Scalars['ID']['input'];
};

/**
 * Cached PropertyExpert question catalog for a pxconnect service request. The
 * insurer's senderId/fetchedAt are intentionally not exposed. All inner fields
 * mirror the PX QuestionResponseDTO/AnswerResponseDTO optionality (nullable except
 * the stable keys) so a missing value never trips an AppSync non-null error.
 */
export type QuestionCatalog = {
  __typename?: 'QuestionCatalog';
  /**
   * True, wenn der Live-Abruf beim SVC nichts geliefert hat und stattdessen der
   * zuletzt gespeicherte Katalog dieses Versicherers ausgeliefert wird (UCPWO-398).
   * Das Portal MUSS das sichtbar machen — sonst verdeckt der Fallback, dass der
   * Abruf kaputt ist.
   */
  fromSnapshot?: Maybe<Scalars['Boolean']['output']>;
  questions: Array<QuestionCatalogQuestion>;
  /** Stand des Fallbacks (ISO-8601). Nur gesetzt, wenn `fromSnapshot` true ist. */
  snapshotSavedAt?: Maybe<Scalars['String']['output']>;
};

export type QuestionCatalogAnswer = {
  __typename?: 'QuestionCatalogAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityDescription?: Maybe<Scalars['String']['output']>;
  relatedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  withComment?: Maybe<Scalars['Boolean']['output']>;
  withQuantity?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionCatalogQuestion = {
  __typename?: 'QuestionCatalogQuestion';
  answers?: Maybe<Array<QuestionCatalogAnswer>>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  isMultipleAnswer?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  parentKey?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ReceiptDateTime = {
  __typename?: 'ReceiptDateTime';
  dateTime: Scalars['String']['output'];
  format: Scalars['String']['output'];
};

export type RejectServiceRequestInput = {
  serviceRequestId: Scalars['ID']['input'];
  userId: Scalars['Int']['input'];
};

export type S3Object = {
  __typename?: 'S3Object';
  bucket?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};

export type S3ObjectInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type Schema = {
  __typename?: 'Schema';
  mutation?: Maybe<Mutation>;
  query?: Maybe<Query>;
  subscription?: Maybe<Subscription>;
};

export type Scratch = {
  __typename?: 'Scratch';
  message?: Maybe<Scalars['String']['output']>;
};

export type SecurityBooleanResponse = {
  __typename?: 'SecurityBooleanResponse';
  data?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<SecurityError>;
};

export type SecurityError = {
  __typename?: 'SecurityError';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['AWSJSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type SecurityGetRoleWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SecurityGetUserWhereInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SecurityMutation = {
  __typename?: 'SecurityMutation';
  createRole?: Maybe<SecurityRoleResponse>;
  createUser?: Maybe<SecurityUserResponse>;
  deleteRole?: Maybe<SecurityBooleanResponse>;
  deleteUser?: Maybe<SecurityBooleanResponse>;
  updateRole?: Maybe<SecurityRoleResponse>;
  updateUser?: Maybe<SecurityUserResponse>;
};


export type SecurityMutationCreateRoleArgs = {
  data: SecurityRoleCreateInput;
};


export type SecurityMutationCreateUserArgs = {
  data: SecurityUserCreateInput;
};


export type SecurityMutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type SecurityMutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type SecurityMutationUpdateRoleArgs = {
  data: SecurityRoleUpdateInput;
  id: Scalars['ID']['input'];
};


export type SecurityMutationUpdateUserArgs = {
  data: SecurityUserUpdateInput;
  id: Scalars['ID']['input'];
};

export type SecurityQuery = {
  __typename?: 'SecurityQuery';
  getRole?: Maybe<SecurityRoleResponse>;
  getUser?: Maybe<SecurityUserResponse>;
  listRoles?: Maybe<SecurityRoleListResponse>;
  listUsers?: Maybe<SecurityUserListResponse>;
};


export type SecurityQueryGetRoleArgs = {
  where: SecurityGetRoleWhereInput;
};


export type SecurityQueryGetUserArgs = {
  where: SecurityGetUserWhereInput;
};

export type SecurityRole = {
  __typename?: 'SecurityRole';
  abbreviation?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  permissionGroups: Array<PermissionGroup>;
  system?: Maybe<Scalars['Boolean']['output']>;
};

export type SecurityRoleCreateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionGroups: Array<PermissionGroupInput>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SecurityRoleListResponse = {
  __typename?: 'SecurityRoleListResponse';
  data?: Maybe<Array<SecurityRole>>;
  error?: Maybe<SecurityError>;
};

export type SecurityRoleResponse = {
  __typename?: 'SecurityRoleResponse';
  data?: Maybe<SecurityRole>;
  error?: Maybe<SecurityError>;
};

export type SecurityRoleUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionGroups: Array<PermissionGroupInput>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SecurityUser = {
  __typename?: 'SecurityUser';
  app?: Maybe<Scalars['AWSJSON']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['AWSDateTime']['output']>;
  role?: Maybe<SecurityRole>;
  roleId?: Maybe<Scalars['String']['output']>;
};

export type SecurityUserCreateInput = {
  app?: InputMaybe<Scalars['AWSJSON']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SecurityUserListResponse = {
  __typename?: 'SecurityUserListResponse';
  data?: Maybe<Array<SecurityUser>>;
  error?: Maybe<SecurityError>;
};

export type SecurityUserResponse = {
  __typename?: 'SecurityUserResponse';
  data?: Maybe<SecurityUser>;
  error?: Maybe<SecurityError>;
};

export type SecurityUserUpdateInput = {
  app?: InputMaybe<Scalars['AWSJSON']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  attachments?: Maybe<Array<Maybe<ServiceRequestAttachment>>>;
  branch?: Maybe<ServiceRequestBranch>;
  client?: Maybe<ServiceRequestClient>;
  /**
   * Gegenstelle, von der SVC den Auftrag geholt hat (UCPWO-398). Null bei Aufträgen von
   * vor dem Stempel — bewusst keine Ableitung aus der Stage.
   */
  connection?: Maybe<ServiceRequestConnection>;
  /**
   * Schadennummer, wie der Auftrag sie nennt (UCPWO-423). Gothaer: `header.schadenNr`,
   * PX Connect: `formattedDamageNumber`. Null, wenn der Auftrag keine trägt.
   */
  damageNumber?: Maybe<Scalars['String']['output']>;
  details?: Maybe<ServiceRequestDetails>;
  /**
   * Folgeauftrag einer Gothaer-Schadennummer (UCPWO-423). Null für den ersten offenen
   * Auftrag einer Schadennummer ohne Projekt und für alle Aufträge ohne Familie.
   */
  followUp?: Maybe<ServiceRequestFollowUp>;
  id: Scalars['ID']['output'];
  /**
   * Versicherer des Auftrags (UCPWO-398). PX Connect: aus `customer.number`, `name` nur
   * für bekannte Nummern. Gothaer: die Integration selbst. Null, wenn nicht bestimmbar.
   */
  insurer?: Maybe<ServiceRequestInsurer>;
  sourceSystem?: Maybe<ServiceRequestSourceSystem>;
};

export type ServiceRequestAttachment = {
  __typename?: 'ServiceRequestAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceRequestBranch = {
  __typename?: 'ServiceRequestBranch';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
};

export type ServiceRequestClient = {
  __typename?: 'ServiceRequestClient';
  address?: Maybe<ServiceRequestClientAddress>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ServiceRequestClientAddress = {
  __typename?: 'ServiceRequestClientAddress';
  city?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type ServiceRequestConnection = {
  __typename?: 'ServiceRequestConnection';
  /** Nur der Hostname, ohne Pfad oder Query. */
  host: Scalars['String']['output'];
  /** `prod` (echtes System), `test` (Testsystem der Gegenstelle) oder `emulate`. */
  kind: Scalars['String']['output'];
};

export type ServiceRequestDetails = {
  __typename?: 'ServiceRequestDetails';
  description?: Maybe<Scalars['String']['output']>;
  receiptDateTime: ReceiptDateTime;
  serviceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ServiceRequestError = {
  __typename?: 'ServiceRequestError';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['AWSJSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ServiceRequestFollowUp = {
  __typename?: 'ServiceRequestFollowUp';
  /**
   * Ein früherer Auftrag derselben Schadennummer wartet noch im Auftragseingang und ist
   * zuerst anzunehmen oder abzulehnen.
   */
  blocked: Scalars['Boolean']['output'];
  damageNumber: Scalars['String']['output'];
  /** Das Projekt, das die Schadennummer schon hat. Null, solange keins angelegt ist. */
  project?: Maybe<ServiceRequestFollowUpProject>;
};

/** Was das Portal für Projektnummer und Link braucht. */
export type ServiceRequestFollowUpProject = {
  __typename?: 'ServiceRequestFollowUpProject';
  anlageDatum: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lfdNr: Scalars['Int']['output'];
  niederlassungNummer: Scalars['Int']['output'];
  /** Das erste Subprojekt der Schadennummer; dorthin verlinkt der Folgeauftrag. */
  subprojectId: Scalars['Int']['output'];
  subprojectLfdNr: Scalars['Int']['output'];
};

export type ServiceRequestInsurer = {
  __typename?: 'ServiceRequestInsurer';
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type ServiceRequestMutationResponse = {
  __typename?: 'ServiceRequestMutationResponse';
  data?: Maybe<ServiceRequest>;
  error?: Maybe<ServiceRequestError>;
};

export type ServiceRequestNotification = {
  __typename?: 'ServiceRequestNotification';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type ServiceRequestNotificationInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type ServiceRequestSourceSystem = {
  __typename?: 'ServiceRequestSourceSystem';
  name?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  documents?: Maybe<DocumentUpload>;
  onProjectUpdate?: Maybe<ProjectNotification>;
  onServiceRequestNotification?: Maybe<ServiceRequestNotification>;
  projectNotifications?: Maybe<ProjectNotification>;
};


export type SubscriptionOnProjectUpdateArgs = {
  id: Scalars['ID']['input'];
};

export type UploadMetadata = {
  __typename?: 'UploadMetadata';
  docLocation?: Maybe<S3Object>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type UploadNotificationInput = {
  analysis?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  pdfDoc?: InputMaybe<Scalars['AWSJSON']['input']>;
  projectNumber?: InputMaybe<Scalars['String']['input']>;
  s3Object?: InputMaybe<S3ObjectInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type Viewer = {
  __typename?: 'Viewer';
  app: App;
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
};

export type ViewerMutation = {
  __typename?: 'ViewerMutation';
  resetAvatar?: Maybe<Scalars['Boolean']['output']>;
  updateAvatar?: Maybe<Scalars['Boolean']['output']>;
};


export type ViewerMutationUpdateAvatarArgs = {
  avatar: Scalars['String']['input'];
};

export type DocumentUploadFragmentFragment = { __typename?: 'DocumentUpload', id?: string | null, timestamp?: string | null, status?: string | null, projectNumber?: string | null, s3Object?: { __typename?: 'S3Object', key?: string | null, versionId?: string | null } | null, metadata?: { __typename?: 'UploadMetadata', filename?: string | null, docLocation?: { __typename?: 'S3Object', key?: string | null } | null } | null };

export type DocumentUploadSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DocumentUploadSubscription = { __typename?: 'Subscription', documents?: { __typename?: 'DocumentUpload', id?: string | null, timestamp?: string | null, status?: string | null, projectNumber?: string | null, s3Object?: { __typename?: 'S3Object', key?: string | null, versionId?: string | null } | null, metadata?: { __typename?: 'UploadMetadata', filename?: string | null, docLocation?: { __typename?: 'S3Object', key?: string | null } | null } | null } | null };

export type DeleteUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUploadMutation = { __typename?: 'Mutation', documents?: { __typename?: 'DocumentsMutation', deleteUpload: boolean } | null };

export type MoveUploadsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  subprojectId: Scalars['ID']['input'];
}>;


export type MoveUploadsMutation = { __typename?: 'Mutation', documents?: { __typename?: 'DocumentsMutation', moveUploads: Array<boolean> } | null };

export type ListUploadsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUploadsQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentsQuery', uploads: Array<{ __typename?: 'DocumentUpload', id?: string | null, timestamp?: string | null, status?: string | null, projectNumber?: string | null, s3Object?: { __typename?: 'S3Object', key?: string | null, versionId?: string | null } | null, metadata?: { __typename?: 'UploadMetadata', filename?: string | null, docLocation?: { __typename?: 'S3Object', key?: string | null } | null } | null } | null> } | null };

export type CreatePdfMutationVariables = Exact<{
  template: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
}>;


export type CreatePdfMutation = { __typename?: 'Mutation', pdf?: { __typename?: 'PdfMutation', createPdf?: { __typename?: 'CreatePdfResponse', signedUrl?: string | null, versionId?: string | null, error?: string | null } | null } | null };

export type SecurityRoleFragmentFragment = { __typename?: 'SecurityRole', id: string, name: string, abbreviation?: string | null, description?: string | null, system?: boolean | null, created?: any | null, modified?: any | null, permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: string, type: PermissionGroupType, permissionSet?: Array<string> | null, resources: Array<{ __typename?: 'PermissionResource', id: string, name?: string | null, permissions: Array<string>, value?: number | null }> }> };

export type CreateRoleMutationVariables = Exact<{
  data: SecurityRoleCreateInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', security?: { __typename?: 'SecurityMutation', role?: { __typename?: 'SecurityRoleResponse', data?: { __typename?: 'SecurityRole', id: string, name: string, abbreviation?: string | null, description?: string | null, system?: boolean | null, created?: any | null, modified?: any | null, permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: string, type: PermissionGroupType, permissionSet?: Array<string> | null, resources: Array<{ __typename?: 'PermissionResource', id: string, name?: string | null, permissions: Array<string>, value?: number | null }> }> } | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRoleQuery = { __typename?: 'Query', security?: { __typename?: 'SecurityQuery', role?: { __typename?: 'SecurityRoleResponse', data?: { __typename?: 'SecurityRole', id: string, name: string, abbreviation?: string | null, description?: string | null, system?: boolean | null, created?: any | null, modified?: any | null, permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: string, type: PermissionGroupType, permissionSet?: Array<string> | null, resources: Array<{ __typename?: 'PermissionResource', id: string, name?: string | null, permissions: Array<string>, value?: number | null }> }> } | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: SecurityRoleUpdateInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', security?: { __typename?: 'SecurityMutation', role?: { __typename?: 'SecurityRoleResponse', data?: { __typename?: 'SecurityRole', id: string, name: string, abbreviation?: string | null, description?: string | null, system?: boolean | null, created?: any | null, modified?: any | null, permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: string, type: PermissionGroupType, permissionSet?: Array<string> | null, resources: Array<{ __typename?: 'PermissionResource', id: string, name?: string | null, permissions: Array<string>, value?: number | null }> }> } | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', security?: { __typename?: 'SecurityMutation', role?: { __typename?: 'SecurityBooleanResponse', data?: boolean | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type ListRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRolesQuery = { __typename?: 'Query', security?: { __typename?: 'SecurityQuery', roles?: { __typename?: 'SecurityRoleListResponse', data?: Array<{ __typename?: 'SecurityRole', id: string, name: string, abbreviation?: string | null, description?: string | null, system?: boolean | null, created?: any | null, modified?: any | null, permissionGroups: Array<{ __typename?: 'PermissionGroup', id: string, name: string, type: PermissionGroupType, permissionSet?: Array<string> | null, resources: Array<{ __typename?: 'PermissionResource', id: string, name?: string | null, permissions: Array<string>, value?: number | null }> }> }> | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type SecurityUserFragmentFragment = { __typename?: 'SecurityUser', id: string, email: string, firstName?: string | null, lastName?: string | null, avatar?: string | null, created?: any | null, modified?: any | null, roleId?: string | null, app?: any | null, role?: { __typename?: 'SecurityRole', id: string, name: string } | null };

export type GetUserQueryVariables = Exact<{
  email: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', security?: { __typename?: 'SecurityQuery', user?: { __typename?: 'SecurityUserResponse', data?: { __typename?: 'SecurityUser', id: string, email: string, firstName?: string | null, lastName?: string | null, avatar?: string | null, created?: any | null, modified?: any | null, roleId?: string | null, app?: any | null, role?: { __typename?: 'SecurityRole', id: string, name: string } | null } | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type ListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersQuery = { __typename?: 'Query', security?: { __typename?: 'SecurityQuery', users?: { __typename?: 'SecurityUserListResponse', data?: Array<{ __typename?: 'SecurityUser', id: string, email: string, firstName?: string | null, lastName?: string | null, avatar?: string | null, created?: any | null, modified?: any | null, roleId?: string | null, app?: any | null, role?: { __typename?: 'SecurityRole', id: string, name: string } | null }> | null, error?: { __typename?: 'SecurityError', code?: string | null, message?: string | null, data?: any | null } | null } | null } | null };

export type AnalyzeAssetQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type AnalyzeAssetQuery = { __typename?: 'Query', analyzeAsset: { __typename?: 'AnalyzeAssetResponse', details: any, status: string } };

export type EInvoiceQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type EInvoiceQuery = { __typename?: 'Query', eInvoice: { __typename?: 'EInvoiceResponse', data?: any | null, error?: { __typename?: 'AssetsError', code?: string | null, message?: string | null, data?: any | null } | null } };

export type ProjectNotificationMutationVariables = Exact<{
  data: ProjectNotificationInput;
}>;


export type ProjectNotificationMutation = { __typename?: 'Mutation', projectNotification?: { __typename?: 'ProjectNotification', id: string, notification?: string | null, message?: string | null, metadata?: any | null } | null };

export type OnProjectUpdateSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnProjectUpdateSubscription = { __typename?: 'Subscription', onProjectUpdate?: { __typename?: 'ProjectNotification', id: string, notification?: string | null, message?: string | null, metadata?: any | null } | null };

export type ServiceRequestNotificationMutationVariables = Exact<{
  input: ServiceRequestNotificationInput;
}>;


export type ServiceRequestNotificationMutation = { __typename?: 'Mutation', serviceRequestNotification: { __typename?: 'ServiceRequestNotification', id: string, message: string } };

export type OnServiceRequestNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnServiceRequestNotificationSubscription = { __typename?: 'Subscription', onServiceRequestNotification?: { __typename?: 'ServiceRequestNotification', id: string, message: string } | null };

export const DocumentUploadFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentUploadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"s3Object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"docLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentUploadFragmentFragment, unknown>;
export const SecurityRoleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityRoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"permissionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"permissionSet"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<SecurityRoleFragmentFragment, unknown>;
export const SecurityUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"}}]}}]} as unknown as DocumentNode<SecurityUserFragmentFragment, unknown>;
export const DocumentUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"documentUpload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentUploadFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentUploadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"s3Object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"docLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentUploadSubscription, DocumentUploadSubscriptionVariables>;
export const DeleteUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]}}]} as unknown as DocumentNode<DeleteUploadMutation, DeleteUploadMutationVariables>;
export const MoveUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveUploads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subprojectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveUploads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"subprojectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subprojectId"}}}]}]}}]}}]} as unknown as DocumentNode<MoveUploadsMutation, MoveUploadsMutationVariables>;
export const ListUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentUploadFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentUploadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"s3Object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"docLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<ListUploadsQuery, ListUploadsQueryVariables>;
export const CreatePdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSJSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}},{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePdfMutation, CreatePdfMutationVariables>;
export const CreateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRoleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"role"},"name":{"kind":"Name","value":"createRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityRoleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityRoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"permissionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"permissionSet"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRoleMutation, CreateRoleMutationVariables>;
export const GetRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"role"},"name":{"kind":"Name","value":"getRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityRoleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityRoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"permissionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"permissionSet"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetRoleQuery, GetRoleQueryVariables>;
export const UpdateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRoleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"role"},"name":{"kind":"Name","value":"updateRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityRoleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityRoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"permissionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"permissionSet"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"role"},"name":{"kind":"Name","value":"deleteRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const ListRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"roles"},"name":{"kind":"Name","value":"listRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityRoleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityRoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"permissionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"permissionSet"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ListRolesQuery, ListRolesQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityUserFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const ListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"listUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecurityUserFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecurityUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"}}]}}]} as unknown as DocumentNode<ListUsersQuery, ListUsersQueryVariables>;
export const AnalyzeAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AnalyzeAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyzeAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"E_INVOICE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<AnalyzeAssetQuery, AnalyzeAssetQueryVariables>;
export const EInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]} as unknown as DocumentNode<EInvoiceQuery, EInvoiceQueryVariables>;
export const ProjectNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"projectNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<ProjectNotificationMutation, ProjectNotificationMutationVariables>;
export const OnProjectUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onProjectUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onProjectUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<OnProjectUpdateSubscription, OnProjectUpdateSubscriptionVariables>;
export const ServiceRequestNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"serviceRequestNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceRequestNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceRequestNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ServiceRequestNotificationMutation, ServiceRequestNotificationMutationVariables>;
export const OnServiceRequestNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onServiceRequestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onServiceRequestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<OnServiceRequestNotificationSubscription, OnServiceRequestNotificationSubscriptionVariables>;